export default class AnimatedScroll {
    constructor() {
        this.selector = 'a[href*="#"]';
        this.init();
    }

    init() {
        let scroll = new SmoothScroll( this.selector, {
            ignore: '[data-scroll-ignore]',
            speed: 1000,
            offset: 60,
            easing: 'easeInOutCubic',
        } );
    }
}